export default "__VITE_ASSET__5919578c__"